import { render } from "./BaseFooter.vue?vue&type=template&id=b2b5486c&scoped=true&ts=true"
import script from "./BaseFooter.vue?vue&type=script&lang=ts"
export * from "./BaseFooter.vue?vue&type=script&lang=ts"

import "./BaseFooter.vue?vue&type=style&index=0&id=b2b5486c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2b5486c"]])

export default __exports__